export class DropDownMenuItem {
  /**
   *
   * id éé¡¹id
   * contentText éé¡¹åå®¹
   * chosen éé¡¹æ¯å¦å·²é
   * disable éé¡¹æ¯å¦ç¦ç¨
   * show éé¡¹æ¯å¦éèï¼éèåï¼ä¸æåè¡¨ä¸­ä¸ä¼æ¾ç¤ºï¼ä½æ¯å¯ä»¥è¢«å¹éä¸­ï¼
   */
  constructor(
    public id: number,
    public contentText: string,
    public chosen = false,
    public disable = false,
    public show = true
  ) {
  }

  copy() {
    return new DropDownMenuItem(this.id, this.contentText, this.chosen, this.disable, this.show);
  }
}
